import Pages from 'pages/index';

function App() {
  return (
    <div className="w-full h-screen flex justify-center items-start bg-gray-400">
      <Pages></Pages>
    </div>
  );
}

export default App;
